export default __webpack_public_path__ + "static/media/689.2c648da0.jpg";